<div class="list-container">
    <dynamic-table [props]="props">
        <table class="table">
            <thead>
                <tr class="table-header">
                    <th id="Type" class="table-header-title">{{ 'insurance.insuranceList.type' | translate }}</th>

                    <th id="ContractNumber" class="table-header-title">{{ 'insurance.insuranceList.contractNumber' | translate }}</th>

                    <th id="InsuranceNumber" class="table-header-title">{{ 'insurance.insuranceList.insuranceNumber' | translate }}</th>

                    <th id="InsuranceCompany" class="table-header-title">{{ 'insurance.insuranceList.insuranceCompany' | translate }}</th>

                    <th id="Categories" class="table-header-title">{{ 'insurance.insuranceList.startDate' | translate }}</th>

                    <th id="Contracts" class="table-header-title">{{ 'insurance.insuranceList.endDate' | translate }}</th>

                    <th id="value" class="table-header-title">{{ 'insurance.insuranceList.totalPremiumAmount' | translate }}</th>

                    <th id="Currency" class="table-header-title">{{ 'insurance.insuranceList.currency' | translate }}</th>

                    <th id="Status" class="table-header-title">{{ 'insurance.insuranceList.status' | translate }}</th>
                </tr>
            </thead>

            <tbody>
                <ng-container *ngFor="let insurance of insurances">
                    <tr class="row-container ccc ccc-table-row ccc-hover" role="button"
                        (click)="navigateToDetailHandler(insurance.insuranceId)">
                        <td HJSuppress id="Type" class="column-content">
                            {{ insurance.insuranceType }}
                        </td>

                        <td HJSuppress id="ContractNumber" class="column-content">
                            {{ insurance.contractNumber }}
                        </td>

                        <td HJSuppress id="InsuranceNumber" class="column-content">
                            {{ insurance.insuranceNumber }}
                        </td>

                        <td HJSuppress id="InsuranceCompany" class="column-content">
                            {{ insurance.insuranceCompany }}
                        </td>

                        <td HJSuppress id="StartDate" class="column-content">
                            {{ insurance.startDate | localizedDate }}
                        </td>

                        <td HJSuppress id="EndDate" class="column-content">
                            {{ insurance.endDate | localizedDate }}
                        </td>
                        
                        <td HJSuppress id="value" class="column-content">
                            {{ insurance.value ? (insurance.value | number : '1.') : '-' }}
                        </td>
        
                        <td HJSuppress id="Currency" class="column-content">
                            {{ insurance.currencyCode }}
                        </td>

                        <td HJSuppress id="Status" class="column-content">
                            <div class="insurance-status-box">
                                <div class="insurance-status-dot" 
                                    [ngClass]="'status-'+(insurance.status).toLowerCase()"
                                >
                                </div>
                                <div class="insurance-status-value">
                                    {{ 'insurance.insuranceList.insuranceStatus.'+(insurance.status).toLowerCase() | translate }}
                                </div>
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </dynamic-table>
</div>

